import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@material-ui/core';
import useTranslation from 'Hooks/useTranslation';

const AddSubscribiedJobModal = ({ isOpen, onCancel, updatedJob, onOpen, licenseName }) => {
    const translation = useTranslation();

    return (
        <Dialog open={isOpen} className='respModal autoHeight'>
            <div className="modalTitleHolder mb16">
                <h1 className='modalTitle'>{translation.newJobAvaliableModalTitle}</h1>
            </div>
            <p className='deleteItemLabel' style={{ marginBottom: '16px', marginTop: '16px' }}>
                A new job {updatedJob?.name} is now available for your license {licenseName}. Would you like to switch to it?
            </p>
            <div className="btnHolder end fixedWidthBtn">
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    id="modalCancelBtn"
                    fullWidth
                >
                    {translation.cancelButtonLabel}
                </Button>
                <Button
                    onClick={onOpen}
                    variant="contained"
                    color="primary"
                    fullWidth
                    id="modalSaveRemoveBtn"
                >
                    Open
                </Button>
            </div>
        </Dialog>
    );
};

export default AddSubscribiedJobModal;